import _ from 'underscore';

var supportedJobTypes = ['Submission', 'PolicyChange', 'Cancellation', 'Renewal'];

function _getJobDetailUISrefByJobType(type, jobNumber) {
    var uisref = 'quote.detail.summary({submissionNumber: "' + jobNumber + '"})';

    switch (type) {
        case 'Submission':
            {
                uisref = 'quote.detail.summary({submissionNumber: "' + jobNumber + '"})';
                break;
            }
        case 'PolicyChange':
            {
                uisref = 'endorsements.detail.summary({policyChangeNumber: "' + jobNumber + '"})';
                break;
            }
        case 'Cancellation':
            {
                uisref = 'cancellation.detail.summary({cancellationNumber: "' + jobNumber + '"})';
                break;
            }
        case 'Reinstatement':
            {
                uisref = 'reinstatement.detail.summary({reinstatementNumber: "' + jobNumber + '"})';
                break;
            }
        case 'Renewal':
            {
                uisref = 'renewal.detail.summary({renewalNumber: "' + jobNumber + '"})';
                break;
            }
        default:
            {
                break;
            }
    }

    return uisref;
}

function _openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber) {
    window.location.href = GPA_PC_ENTRY_POINT + '?JobNumber=' + jobNumber;
}

function _isSupportJobType(type) {
    return _.contains(supportedJobTypes, type);
}

export default {
    'getJobDetailUISrefByJobType': function getJobDetailUISrefByJobType(type, jobNumber) {
        return _getJobDetailUISrefByJobType(type, jobNumber);
    },
    'openJobInXCenter': function openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber) {
        return _openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
    },
    'isSupportJobType': function isSupportJobType(type) {
        return _isSupportJobType(type);
    }
};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/util/JobUtil.js
// module id = 100
// module chunks = 0